import { type HTMLAttributes, type RefObject, type TdHTMLAttributes, type ThHTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

const Table = ({
  className,
  ref,
  ...props
}: HTMLAttributes<HTMLTableElement> & { ref?: RefObject<HTMLTableElement | null> }) => (
  <div className="relative w-full overflow-auto">
    <table className={cn('w-full caption-bottom text-sm', className)} ref={ref} {...props} />
  </div>
)
Table.displayName = 'Table'

const TableHeader = ({
  className,
  ref,
  ...props
}: HTMLAttributes<HTMLTableSectionElement> & { ref?: RefObject<HTMLTableSectionElement | null> }) => (
  <thead className={cn('[&_tr]:border-b', className)} ref={ref} {...props} />
)
TableHeader.displayName = 'TableHeader'

const TableBody = ({
  className,
  ref,
  ...props
}: HTMLAttributes<HTMLTableSectionElement> & { ref?: RefObject<HTMLTableSectionElement | null> }) => (
  <tbody className={cn('[&_tr:last-child]:border-0', className)} ref={ref} {...props} />
)
TableBody.displayName = 'TableBody'

const TableRow = ({
  className,
  ref,
  ...props
}: HTMLAttributes<HTMLTableRowElement> & { ref?: RefObject<HTMLTableRowElement | null> }) => (
  <tr
    className={cn('border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted', className)}
    ref={ref}
    {...props}
  />
)
TableRow.displayName = 'TableRow'

const TableHead = ({
  className,
  ref,
  ...props
}: ThHTMLAttributes<HTMLTableCellElement> & { ref?: RefObject<HTMLTableCellElement | null> }) => (
  <th
    className={cn(
      'h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0',
      className
    )}
    ref={ref}
    {...props}
  />
)
TableHead.displayName = 'TableHead'

const TableCell = ({
  className,
  ref,
  ...props
}: TdHTMLAttributes<HTMLTableCellElement> & { ref?: RefObject<HTMLTableCellElement | null> }) => (
  <td className={cn('p-4 align-middle [&:has([role=checkbox])]:pr-0', className)} ref={ref} {...props} />
)
TableCell.displayName = 'TableCell'

export { Table, TableBody, TableCell, TableHead, TableHeader, TableRow }
